import EmoticonsAction from './EmoticonsAction.container';

export default EmoticonsAction;
